import {Component, ViewChild} from '@angular/core';
import {PersonalDetailsSectionService} from '../../model/personal-details-section.service';
import {CountryService} from '../../../../domain/model/info/country/country.service';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {NgForm} from '@angular/forms';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {ReplaySubject} from 'rxjs';
import {AddressModel} from '../../../../components/forms/controls/addresspicker/addresspicker.component';
import {AddressMapper} from '../../../../domain/model/common/mappers/address-mapper.class';
import {ContactInfo} from '../../model/contact-info.model';
import {BackendError} from '../../../../common/error/backend-error.class';
import {MessageService} from '../../../../components/messages/message.service';
import {UserService} from '../../../../domain/model/user/user.service';
import {VerificationService} from '../../../../components/verification/service/verification.service';
import {AuthService} from '../../../../components/security/authorization/auth.service';
import {Roles} from '../../../../domain/authorization/roles';

@Component({
    template: require('./contact-screen.component.html'),
    styles: [require('./contact-screen.component.scss')]
})
export class ContactScreenComponent {

    constructor(private _authService: AuthService,
                private readonly _personalDetailsService: PersonalDetailsSectionService,
                countryService: CountryService,
                private readonly _userService: UserService,
                private readonly _messageService: MessageService,
                readonly verificationService: VerificationService) {
        this.verificationService.setUrl('section/personalDetails');
        countryService.getCountriesProjection().subscribe(countries => this.countries = countries.map(c => c.name));
        countryService.getStates().subscribe(states => this.states = states.map(s => s.name));

        this.stepScreenModel.dataModel$.subscribe(m => {
            this._updateEmailChangeFields(m.user);
        });

        this._authService.user$.take(1).subscribe(user => {
            this.isAdmin = user && user.hasAnyRole([Roles.ADMIN]) || false;
        });
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);
    private _form: NgForm;

    @ViewChild(NgForm)
    set form(value: NgForm) {
        this._form = value;
        this.form$.next(value);
    }

    // endregion

    countries: Array<string> = [];
    states: Array<string> = [];
    phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

    //region Email-Change Fields
    emailChangeInfoMessage: string = '';

    private _currentLoginEmail: string;
    pendingEmailChange: boolean;

    private _previousEmailFieldValue: string;

    private get _emailFieldWasChanged(): boolean {
        return this.model.user.email1 !== this._previousEmailFieldValue;
    }

    existingEmailError = false;

    editingEmail = false;
    isAdmin: boolean = false;
    //endregion

    private readonly _addressMapper = new AddressMapper();

    stepScreenModel = new StepScreenModel<ContactInfo>({
        initialDataModel: new ContactInfo(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            return this._personalDetailsService.currentUserContactInfo();
        },
        _submitDataFn: (model: ContactInfo) => {
            this._resetErrors();
            return this._personalDetailsService.updateCurrentUserContactInfo(model)
                .do(() => {
                    if (this._emailFieldWasChanged && !this.isAdmin) this._messageService.success(
                        'Info',
                        this.emailChangeInfoMessage,
                        30
                    );
                });
        },
        _error: (error?: BackendError) => {
            if (error && error.name === 'ExistingUsernameError') this.existingEmailError = true;
        }
    });

    get model(): ContactInfo {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleAddressUpdated(addressModel: AddressModel) {
        this._addressMapper.update(this.model.profile.address, addressModel);
    }

    private _resetErrors() {
        this.existingEmailError = false;
    }

    //region Email-Change
    private _updateEmailChangeFields(user) {
        this._currentLoginEmail = user.email1;
        this.emailChangeInfoMessage = `Your request for changing the email has been successfully submitted, however, you will still need to keep using your old email address (${this._currentLoginEmail}) for login until you verify the new one.`;
        this.pendingEmailChange = !!user.emailChange.email;
        if (this.pendingEmailChange) {
            user.email1 = user.emailChange.email;
        }
        this._previousEmailFieldValue = user.email1!;
    }

    //region Resend Email-Change Verification
    resendingEmailChangeVerification = false;

    get resendEmailChangeVerificationButtonDisabledValue(): string | null {
        return this.resendingEmailChangeVerification ? '' : null;
    }

    resendEmailChangeVerification() {
        if (!this.resendingEmailChangeVerification) {
            this.resendingEmailChangeVerification = true;
            this._userService.resendEmailChangeVerificationForCurrentUser().subscribe(() => {
                this.resendingEmailChangeVerification = false;
                this._messageService.success('Info', 'A new email verification has been sent.');
            });
        }
    }

    //endregion

    //region Cancel Email-Change Verification
    cancelingEmailChange = false;

    get cancelEmailChangeButtonDisabledValue(): string | null {
        return this.cancelingEmailChange ? '' : null;
    }

    cancelEmailChange() {
        this.cancelingEmailChange = true;
        this._userService.cancelEmailChangeForCurrentUser().subscribe(() => {
            this.model.user.emailChange = {};
            this.pendingEmailChange = false;
            this.model.user.email1 = this._previousEmailFieldValue = this._currentLoginEmail;
            this.cancelingEmailChange = false;
            this._form.form.get('email').markAsPristine();
        });
    }

    //endregion

    editEmail(event: FocusEvent) {
        if (!this.editingEmail && !this.isAdmin) {
            if (confirm('Please note that changing the email requires verification. Once verified, you will be using the new email to login.')) {
                this.editingEmail = true;
            }
        }
    }

    //endregion
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/personal-details/steps/contact/contact-screen.component.ts